import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=6a3d3148&scoped=true"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"
import style0 from "./Sider.vue?vue&type=style&index=0&id=6a3d3148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d3148",
  null
  
)

export default component.exports